import { Component, computed, EventEmitter, Input, model, OnInit, Output, Signal, signal, WritableSignal } from '@angular/core';
import { LoginServices } from 'src/app/auth/login/services/login.service';
import { UsuarioAsignado } from 'src/app/officials/asignaciones/interfaces/asignacion-interface';
import { ProyectoItem, CatalogoInterface, ProyectoTramiteItem } from 'src/app/users/interfaces/proyecto.interface';
import { ProyectoDataService } from 'src/app/users/proyectos/services/proyecto-data.service';
import { DropdownModule } from "primeng/dropdown";
import { PrimeNgModule } from "src/app/shared/prime-ng/prime-ng.module";
import { LoaderSpinnerComponent } from "src/app/shared/components/loader-spinner/loader-spinner.component";
import { InputTextModule } from 'primeng/inputtext';
import { CambioRegistroInterface, FlujoTramiteResponse, PreviewCambioRegistroRequest } from '../../interface/cambio-registro.interface';
import { CambioRegistroService } from 'src/app/users/proyectos/services/cambio-registro.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { RpService } from 'src/app/users/registro-profesionales/services/rp.service';
import { RpCreateDlgComponent } from "src/app/users/registro-profesionales/components/rp-create-dlg/rp-create-dlg.component";
import { RpReq } from 'src/app/users/registro-profesionales/interfaces/tipos';

@Component({
  selector: 'app-dialog-cambiar-registro',
  standalone: true,
  imports: [DropdownModule, PrimeNgModule, LoaderSpinnerComponent, InputTextModule, RpCreateDlgComponent],
  templateUrl: './dialog-cambiar-registro.component.html',
  styleUrl: './dialog-cambiar-registro.component.scss'
})
export class DialogCambiarRegistroComponent implements OnInit{
    @Input() tramiteSolicitud!: ProyectoTramiteItem;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() registroActualizado = new EventEmitter<void>();
    @Input() idTramite: string = '';
    @Input() personaMigrada: RpReq | null = null;
    private _visible = false;
    private _selectedProyecto: ProyectoItem | null = null;

    @Input()
    set visible(value: boolean) {
        this._visible = value;
        if (value && this.idTramite) {
        this.cargarTramitesRelacionados();
        this.validacionMigracion();
        }
    }
    get visible(): boolean {
        return this._visible;
    }

    @Input()
    set selectedProyecto(value: ProyectoItem | null) {
        this._selectedProyecto = value;
    }

    get selectedProyecto(): ProyectoItem | null {
        return this._selectedProyecto;
    }

    tramiteRegistro: WritableSignal<string | null> = signal(null);
    tramiteRelacionados!: FlujoTramiteResponse | null;
    tramiteRenovacion = signal<FlujoTramiteResponse[]>([]);
    tramiteUnificacion = signal<FlujoTramiteResponse[]>([]);
    tramitePrimeraVez = signal<FlujoTramiteResponse[]>([]);
    selectedTramiteCambio = signal<FlujoTramiteResponse | null>(null);
    tieneMigracion = signal<boolean>(false);

    isLoading = signal(false);

    constructor(protected ls: LoginServices, public pds: ProyectoDataService, private cambioRegistroService: CambioRegistroService,
        protected rpService: RpService
    ) {}
    ngOnInit(): void {
    }

    tramiteSeleccionado(): FlujoTramiteResponse | null {
        const nombre = this.tramiteRegistro()?.toUpperCase();
        if (!nombre) return null;

        if (nombre.includes('UNIFICACION')) {
            return this.tramiteUnificacion()[0] || null;
        }

        if (nombre.includes('PRIMERA VEZ')) {
            return this.tramitePrimeraVez?.()[0] || null;
        }

        if (nombre.includes('RENOVACION')) {
            return this.tramiteRenovacion()[0] || null;
        }

        return null;
    }

    cargarTramitesRelacionados() {
        this.cambioRegistroService.previewTramitesRegistro(this.idTramite).subscribe({
        next: (resp) => {
            this.tramiteRelacionados = resp[0]!;
            this.tramiteRenovacion.set(resp.filter(t => t.nombreTramite.toUpperCase().includes('RENOVACION')));
            this.tramiteUnificacion.set(resp.filter(t => t.nombreTramite.toUpperCase().includes('UNIFICACION')));
            this.tramitePrimeraVez.set(resp.filter(t => t.nombreTramite.toUpperCase().includes('PRIMERA VEZ')));
        },
        error: (err) => {
            console.error('Error al cargar trámites relacionados', err);
        }
        });
    }

    opcionesTramites = computed(() => [
        ...this.tramiteRenovacion(),
        ...this.tramiteUnificacion(),
        ...this.tramitePrimeraVez(),
    ]);

    isOpcionDeshabilitada(opcion: any): boolean {
        const actual = (this.tramiteSolicitud?.nombreTramite ?? '').trim().toUpperCase();
        const opcionNombre = (opcion?.nombreTramite ?? '').trim().toUpperCase();

        if (opcionNombre === actual) {
            return true;
        }
        if (actual.toUpperCase().includes('UNIFICACION') && opcionNombre.toUpperCase().includes('PRIMERA VEZ')) {
            return true;
        }

        return false;
    }


    opcionesTramitesValidas = computed(() => {
        const tramiteActual = (this.tramiteSolicitud?.nombreTramite ?? '').toUpperCase();

        return this.opcionesTramites()
            .filter(op => !this.isOpcionDeshabilitada(op))
            .filter(op =>
            !tramiteActual.toUpperCase().includes('UNIFICACION') || (op?.nombreTramite ?? '').toUpperCase().includes('RENOVACION')
        );
    });

    obtenerFlujoTramiteSeleccionado(): FlujoTramiteResponse | null {
        const tramite = [
            ...this.tramiteRenovacion(),
            ...this.tramiteUnificacion(),
            ...this.tramitePrimeraVez()
        ].find(t =>
            String(t.idTramite) === String(this.tramiteSolicitud.idTramite) &&
            t.nombreTramite.toUpperCase() === this.tramiteSolicitud.nombreTramite.toUpperCase()
        );

        return tramite || null;
    }

    validacionMigracion() {
        const profesion = this.personaMigrada?.profesion.normalize('NFD').replace(/\p{M}+/gu, '');
        this.cambioRegistroService.personaTieneMigracion(
            this.personaMigrada?.numDocumento || '',
            profesion || ''
        ).subscribe({
            next: (res) => {
                this.tieneMigracion.set(res);
            },
            error: (err) => {
                console.error('Error al verificar migración', err);
            },
            complete: () => {
                console.log('Verificación de migración completada');
            }
        });
    }

    procesarCambioRegistro(){
        Swal.fire({
            icon: 'warning',
            title: 'Cuidado',
            text: 'Esta acción no se puede revertir',
            confirmButtonText: "Si, cambiar registro",
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
            customClass: {
                container: "swal-zindex-fix"
            }
        }).then((result) => {
            if(result.isConfirmed){
                const payload: CambioRegistroInterface = {
                    idProyecto: this.selectedProyecto?.idProyecto!,
                    idSolicitud: this.selectedProyecto?.idSolicitud!,
                    numeroExpediente: this.selectedProyecto?.numeroExpediente!,
                    nombreTramiteViejo: this.tramiteSolicitud.nombreTramite! || '',
                    nombreTramiteNuevo: this.selectedTramiteCambio()?.nombreTramite! || '',
                    idTarifarioDet: null,
                    idSolicitudDet: null,
                    idTramiteViejo: this.tramiteSolicitud.idTramite || 0,
                    idTramiteNuevo: this.selectedTramiteCambio()?.idTramite || 0,
                    idFlujoTramiteViejo: this.obtenerFlujoTramiteSeleccionado()?.idFlujoTramite || 0,
                    idFlujoTramiteNuevo: this.selectedTramiteCambio()?.idFlujoTramite || 0,
                    idEstado: 2,
                    subTotal: this.selectedTramiteCambio()?.subTotal || 0,
                    qtyRqGlobal: this.selectedTramiteCambio()?.requisitosGlobales || 0,
                    qtyRqRequeridos: this.selectedTramiteCambio()?.requisitosRequeridos || 0,
                    qtyRqCumplidos: this.selectedTramiteCambio()?.requisitosCumplidos || 0,
                    correoUsuario: this.selectedProyecto?.creadoPor!,
                    nombreProyectoNuevo: this.selectedTramiteCambio()?.nombreTramite!,
                    modificadoPor: this.ls.session()?.perfil.correo!
                };
                console.log('Procesando cambio de registro con payload: -------->', payload);
                this.cambioRegistroService.procesarCambioRegistro(payload).subscribe({
                    next: (resp) => {
                        this.visibleChange.emit(false);
                        this.registroActualizado.emit();
                        Swal.fire({
                            icon: 'success',
                            title: 'Cambio Exitoso',
                            text: 'Se realizó el cambio de registro.',
                            confirmButtonText: 'Ok'
                        })
                    },
                    error: (err) => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Ocurrio un error al realizar el cambio',
                            confirmButtonText: 'Ok',
                            customClass: {
                                container: "swal-zindex-fix"
                            }
                        })
                        console.error('Error al procesar cambio de registro', err);
                    }
                });
            }
        })

    }

    onClose() {
        this.visible = false;
        this.visibleChange.emit(false);
    }
}
